import goodleapApi from "../api/goodleap-api";

export const getGoodLeapTpoPricing = async (payload) => {
  try {
    const response = await goodleapApi.getTPOPricingV2(payload);
    return response;
  } catch (error) {
    throw new Error(`Error: Could not get GoodLeap TPO Pricing: ${error.status} ${error.statusText} ${error.url}`);
  }
};

export const getGoodLeapTpoOffers = async (payload) => {
  try {
    const response = await goodleapApi.getTPOOffersV2(payload);
    return response;

  } catch (error) {
    throw new Error(`Error: ${error.message}\nCould not get GoodLeap TPO Offers: ${error?.message ? error.message : ""} \n${error?.status ? error.status : ""} ${error?.statusText ? error.statusText : ""} ${error?.url ? error.url : ""}`);
  }
};

export const postShareLoanApplication = async (payload) => {
  try {
    const response = await goodleapApi.shareLoanApplication(payload);
    return response;

  } catch (error) {
    throw new Error(`Error: Could not share GoodLeap TPO application: ${error.status} ${error.statusText} ${error.url}`);
  }
};

export const postSubmitChangeOrder = async (payload) => {
  try {
    const response = await goodleapApi.submitChangeOrder(payload);
    return response;

  } catch (error) {
    throw new Error(`Error: Could not submit GoodLeap TPO change order: ${error.status} ${error.statusText} ${error.url}`);
  }
};

export const getSigningDocs = async (payload) => {
  try {
    const response = await goodleapApi.getSigningDocs(payload);
    return response;

  } catch (error) {
    throw new Error(`Error: Could not share GoodLeap TPO loan application: ${error.status} ${error.statusText} ${error.url}`);
  }
}

export const getExistingSavings = async (payload) => {
  try {
    const response = await goodleapApi.getExistingSavings(payload);
    return response;

  } catch (error) {
    throw new Error(`Error: Could not get GoodLeap existing savings: ${error.status} ${error.statusText} ${error.url}`);
  }
}

export const resendTpoDocs = async (payload) => {
  try {
    const response = await goodleapApi.resendTpoDocs(payload);
    return response;
  } catch (error) {
    throw new Error(`Error: Could not resend loan docs: ${error.statusText}`);
  }
}